import React , { useState } from 'react'

import { ApiCallPost } from '../ApiCall/ApiCall'

export default function Monedas({moneda , done , fechaToday }) {
  
  const [descripcion , setDescripcion] = useState("")

  const [theFechaFinal , setTheFechaFinal] = useState(null)

  function setFechaFinal( val )
  {
    console.log("onMoneda = ", val)

    setTheFechaFinal( val )
  }


  function onSubmit( e )
  {
    e.preventDefault()

    console.log("onSubmit")

  

    var data = {
      c_moneda: moneda.substring( 0 , 6 ),
      descripcion: descripcion ,
      finicio : fechaToday,
      ffin : theFechaFinal,
      dTimeStamp : new Date() 
    }

    console.log("data = ", data)

    ApiCallPost( "savemoneda" , data )
    .then( (response) => {

      console.log("response = ", response)

      if ( response === 0 )
      {
        alert("La moneda ya existe")
        done() ; // Indicamos que ya esta hecho
        return ;
      }

      alert("Moneda Agregada")

      done() ; // indicamos que ya esta hecho

    })
    .catch( (error) => {
      console.log("error = ", error)
      alert("Error al agregar moneda")
    })

    

  }

  function onDescripcion( val2 )
  {
    

    var val = document.getElementById("descripcion").value

    console.log("onDescripcion = ", val )

    setDescripcion( val )
  }

  return (
    <div>
      <form onSubmit={onSubmit}>
        <div className="row mt-5">
          <div className="col-4">

            <label className="form-label m-0" htmlFor="mondesa">Moneda</label>
                <input type="text" className="form-control" id="precio" readOnly value={moneda}
                style={{marginTop:6,height:'40px'}}/>

          </div>

          <div className="col-4">

            <label className="form-label m-0" htmlFor="fechafin">Fecha Final</label>
              <input style={{height:'40px'}} type="date" 
              className="form-control pt-3 mt-2" id="fechafin" onChange={(e) => setFechaFinal(e.target.value)} />


          </div>


          <div className='col-4'>

          <label className="form-label m-0" htmlFor="descripcion">Descripcion</label>
                <input type="text" className="form-control" id="descripcion"
                style={{marginTop:6,height:'40px'}} onChange={(val) =>onDescripcion(val)}/>

          </div>
        </div>

        <div className='row mt-5'>
          <div className='col-6'>
            <button type='submit' className="btn btn-primary mt-3 button-3">Agregar Moneda</button>
          </div>
        </div>
      </form>
    </div>
  )
}
